import type { ProjectionController, ProjectionMode } from './ProjectionController';
import { OrthographicProjectionController } from './OrthographicProjectionController';
import { PerspectiveProjectionController } from './PerspectiveProjectionController';

export type { ProjectionController, ProjectionMode } from './ProjectionController';

export function createProjectionController(mode: ProjectionMode): ProjectionController {
  return mode === 'orthographic'
    ? new OrthographicProjectionController()
    : new PerspectiveProjectionController();
}
